import { Component, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UniversalCrud } from '../../models/universal.model';
import { LoaderService } from '../../service/loader.service';
import { Message } from '../../service/message.service';
import { RestService } from '../../service/rest.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-universal-crud',
  templateUrl: './universal-crud.component.html',
  styles: [`
    .custom-scrollbar-for-custom-filters::-webkit-scrollbar {
      width: 0.6vh;
      height: 0.6vh;
    }

    .custom-scrollbar-for-custom-filters::-webkit-scrollbar-thumb {
      background: var(--primary);
      border-radius: 9999px;
      cursor: grab;
    }

    .custom-scrollbar-for-custom-filters::-webkit-scrollbar-thumb:active {
      cursor: grabbing !important;
    }

    .custom-scrollbar-for-custom-filters::-webkit-scrollbar-track {
      background: transparent;
    }
  `],
  standalone: false,
})
export class UniversalCrudComponent implements OnInit {
  constructor(
    private router: ActivatedRoute,
    private route: Router,
    private loader: LoaderService,
    private message: Message,
    private rest: RestService,
    private viewContainerRef: ViewContainerRef,
    private translocoService: TranslocoService
  ) {}

  @ViewChild('customFiltersUniversalCrudContainer', { read: ViewContainerRef, static: true })
  customFiltersUniversalCrudContainerRef!: ViewContainerRef;
  @ViewChild('customTableUniversalCrudContainer', { read: ViewContainerRef, static: true })
  customTableUniversalCrudContainerRef!: ViewContainerRef;
  @ViewChild('customPaginatorUniversalCrudContainer', { read: ViewContainerRef, static: true })
  customPaginatorUniversalCrudContainerRef!: ViewContainerRef;
  @ViewChild('customExtraComponentUniversalCrudContainer', { read: ViewContainerRef, static: true })
  customExtraComponentUniversalCrudContainerRef!: ViewContainerRef;
  currentItemBeforeChanges :any = {}
  specialModalTimeToShow: any;
  tempVariable: any;
  currentPage = 1;
  totalPages = 1;
  dataTable: any[] = [];
  dataParams: UniversalCrud = {
    breadcrumb: [],
    endpoint: '',
    canAddElement: false,
    canEditElement: false,
    canDeleteElement: false,
    table: [],
    environment: {},
    api: {},
    stepMinutes: 5,
    showClock: true,
    use24h: true,
  };
  currentItem: any = {};
  customForm: any = {};
  myFormData: any;
  showModal = false;
  showModalDelete = false;
  showFilters = false;

  // --- VARIABILI MODALE CUSTOM BANDI ---
  showCustomModal: boolean = false;
  selectedCustomItem: any = null;
  evaluationForm: any = {
    partitaIva: '',
    numeroDipendenti: null,
    cittaSedi: [{ value: '' }],
    codiciAteco: [{ value: '' }],
    fatturati: [{ value: null }, { value: null }, { value: null }]
  };

  filtersList: any[] = [];
  baseFiltersList: any[] = [];
  static myTranslations: any = {};
  filtersData: any[] = [];
  maxItems = -3;
  totalItems = -1;
  listOfDataForSelects: any = {};
  listOfDataForBaseSelects: any = {};
  myCustomFormData: any = new FormData();
  endPointBackend: string = '';
  elementId: string = 'id';

  ngOnInit(): void {
    this.router.data.subscribe((data: any) => {
      if (data.useUrl) {
        data.endpoint = window.location.pathname;
      }
      this.dataParams = data;
      this.endPointBackend = this.dataParams.api.baseUrl;
      this.checkCustomParts();
      this.getTranslationLabels();
      if (this.dataParams.elementId) {
        this.elementId = this.dataParams.elementId;
      }
      if (this.dataParams.environment.testing) {
        this.totalPages = 5;
      }
      this.filtersData = data.table.filter(
        (tableItem: any) => tableItem.filterable
      );
      if (this.dataParams.maxItems) {
        this.dataParams.maxItems.subscribe({
          next: (value: any) => {
            this.maxItems = value;
          },
        });
      }
      if (this.dataParams.fatherEndpoint) {
        this.rest.get(this.dataParams.fatherEndpoint).subscribe({
          next: (value: any) => {
            this.dataParams.endpoint =
              this.dataParams.fatherExtraEndpoint +
              (this.dataParams.isFatherValueArray
                ? value[0][this.dataParams.fatherValue ?? '']
                : value[this.dataParams.fatherValue ?? '']) +
              this.dataParams.endpoint;
            data.table.forEach((element: any) => {
              if (element?.selectDataEndpoint) {
                this.getDataForSelect(
                  element?.selectDataEndpoint,
                  element.element
                );
              }
            });
            if (
              this.dataParams?.baseFilters &&
              this.dataParams?.baseFilters?.length > 0
            ) {
              this.dataParams.baseFilters.forEach((baseFilter: any) => {
                if (baseFilter.endpoint) {
                  this.getDataForBaseSelect(
                    baseFilter.endpoint,
                    baseFilter.value,
                    baseFilter.isPaginated,
                    baseFilter
                  );
                }
              });
            }
            this.getTableData();
          },
        });
      } else {
        data.table.forEach((element: any) => {
          if (element?.selectDataEndpoint) {
            this.getDataForSelect(element?.selectDataEndpoint, element.element);
          }
        });
        if (
          this.dataParams?.baseFilters &&
          this.dataParams?.baseFilters?.length > 0
        ) {
          this.dataParams.baseFilters.forEach((baseFilter: any) => {
            if (baseFilter.endpoint) {
              this.getDataForBaseSelect(
                baseFilter.endpoint,
                baseFilter.value,
                baseFilter.isPaginated,
                baseFilter
              );
            }
          });
        }
        this.getTableData();
      }
    });
  }




  getTranslationLabels() {
    this.translocoService.selectTranslation(this.translocoService.getActiveLang()).subscribe((res) => {
      UniversalCrudComponent.myTranslations = res;
    });
  }

  t(label: any) {
    return UniversalCrudComponent.myTranslations && label ? UniversalCrudComponent.myTranslations[label] : label;
  }

  changeBaseSelect(event: any, baseFilter: any) {
    let indexToAdjust = this.baseFiltersList.findIndex(
      (baseF: any) => baseF.s === baseFilter.value
    );
    if (indexToAdjust == -1) {
      this.baseFiltersList.push({
        s: baseFilter.value,
        v: event[baseFilter.bindValue],
        o: null,
      });
    } else {
      this.baseFiltersList[indexToAdjust] = {
        s: baseFilter.value,
        v: event[baseFilter.bindValue],
        o: null,
      };
    }
    this.getTableData();
  }

  generateCustomAction(component: Type<any>, item?: any) {
    setTimeout(() => {
      const componentRef = this.viewContainerRef.createComponent(component);
      componentRef.instance.fatherElement = item;
      componentRef.instance.fatherContaierRef = this;
    }, 0);
  }

  showCreationPage() {
    if (this.dataParams.usePageCreation) {
      this.route.navigate([(`${this.t(this.dataParams.usePageCreation.route)}`)]);
    }
  }

  checkCustomParts() {
    if (this.dataParams.customFilters) {
      this.customFiltersUniversalCrudContainerRef.clear();
      const componentFiltersRef = this.customFiltersUniversalCrudContainerRef.createComponent(this.dataParams.customFilters);
      componentFiltersRef.instance.fatherContaierRef = this;
    }
    if (this.dataParams.customTable) {
      this.customTableUniversalCrudContainerRef.clear();
      const componentTableRef = this.customTableUniversalCrudContainerRef.createComponent(this.dataParams.customTable);
      componentTableRef.instance.fatherContaierRef = this;
    }
    if (this.dataParams.customPaginator) {
      this.customPaginatorUniversalCrudContainerRef.clear();
      const componentPaginatorRef = this.customPaginatorUniversalCrudContainerRef.createComponent(this.dataParams.customPaginator);
      componentPaginatorRef.instance.fatherContaierRef = this;
    }
    if (this.dataParams.customExtraComponent) {
      this.customExtraComponentUniversalCrudContainerRef.clear();
      const componentPaginatorRef = this.customExtraComponentUniversalCrudContainerRef.createComponent(this.dataParams.customExtraComponent);
      componentPaginatorRef.instance.fatherContaierRef = this;
    }
  }

  manageFiles(event: any, dataForm: any) {
    const file = event.target.files[0];
    this.myCustomFormData.set(dataForm.element, file);
  }

  getDataForBaseSelect(
    endpoint: string,
    property: string,
    isPaginated: boolean,
    baseFilter: any
  ) {
    this.loader.on();
    this.rest.get(`${endpoint}`).subscribe({
      next: (response: any) => {
        this.listOfDataForBaseSelects[property] = isPaginated
          ? response.data
          : response;
        this.loader.off(true);
        if (this.listOfDataForBaseSelects[property].length == 1) {
          this.changeBaseSelect(this.listOfDataForBaseSelects[property][0], baseFilter);
        }
      },
      error: () => {
        this.loader.off(true);
      },
    });
  }

  getDataForSelect(endpoint: string, property: string) {
    this.loader.on();
    this.rest.get(`${endpoint}`).subscribe({
      next: (response: any) => {
        if(property == 'parentId'){
          this.listOfDataForSelects[property] = response.data.map((res:any)=>{
            res.ragioneSociale = res.profile?.ragioneSociale ?? 'Nessun nome'
            return res
          });
        }else{
        this.listOfDataForSelects[property] = response;}
        this.loader.off(true);
      },
      error: () => {
        this.loader.off(true);
      },
    });
  }

  addFilter(myFilter: any) {
    this.filtersList.push({ s: myFilter.element, v: null, o: null, ops: this.getOperators(myFilter) });
  }

  removeFilter(index: number) {
    setTimeout(() => {
      this.filtersList.splice(index, 1);
    }, 0);
  }

  activeFilters() {
    this.currentPage = 1;
    this.totalPages = 1;
    this.getTableData();
    this.showFilters = false;
  }

  resetFilters() {
    this.showFilters = false;
    this.filtersList = [];
    this.currentPage = 1;
    this.totalPages = 1;
    this.dataTable = [];
    this.getTableData();
  }

  hasOperator(element: string) {
    if (element) {
      return this.filtersData.find((myFilter) => myFilter.element == element).operator;
    } else {
      return false;
    }
  }

  findElement(element: string) {
    return this.filtersData.find((myFilter) => myFilter.element == element);
  }

  getValue($event: any) {
    return $event.element ? $event.element : $event.value;
  }

  getOperators(event: any) {
    let myOperators: { value: number; label: string }[] = [];

    if (event.operators) {
      const operators = [
        { key: 'equal', value: 1, label: 'operators.EQ' },
        { key: 'greaterThan', value: 2, label: 'operators.GT' },
        { key: 'lessThen', value: 3, label: 'operators.LT' },
        { key: 'greaterThanOrEqual', value: 4, label: 'operators.GTE' },
        { key: 'lessThanOrEqual', value: 5, label: 'operators.LTE' },
        { key: 'like', value: 6, label: 'operators.LIKE' },
        { key: 'in', value: 7, label: 'operators.IN' },
        { key: 'notEqual', value: 8, label: 'operators.NOT_EQ' },
        { key: 'between', value: 9, label: 'operators.BETWEEN' },
        { key: 'notIn', value: 10, label: 'operators.NOT_IN' },
        { key: 'notNull', value: 11, label: 'operators.NOT_NULL' },
        { key: 'null', value: 12, label: 'operators.NULL' },
      ];

      myOperators = operators
        .filter((op) => event.operators[op.key])
        .map((op) => ({ value: op.value, label: this.t(op.label) }));
    } else {
      myOperators.push({ value: 1, label: this.t('operators.EQ') });
      myOperators.push({ value: 6, label: this.t('operators.LIKE') });
      myOperators.push({ value: 12, label: this.t('operators.NULL') });
      myOperators.push({ value: 11, label: this.t('operators.NOT_NULL') });
      switch (event.type) {
        case 'number':
        case 'date':
          myOperators.push({ value: 2, label: this.t('operators.GT') });
          myOperators.push({ value: 4, label: this.t('operators.GTE') });
          myOperators.push({ value: 3, label: this.t('operators.LT') });
          myOperators.push({ value: 5, label: this.t('operators.LTE') });
          break;
      }
    }

    return myOperators;
  }

  initializeBetweenOperatorArray(filter: any) {
    filter.v = [null, null];
  }

  showDetails(item: any) {
    if (this.dataParams.details) {
      this.route.navigate([(`${this.t(this.dataParams.details.route)}/`).replace(':id', item[this.elementId])]);
    }
  }

  getFormattedDate(myDate: Date) {
    const date = new Date(myDate);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  }

  getTableData() {
    if (this.dataParams.environment.testing) {
      if (this.dataParams?.mockData?.length > 0) {
        this.dataTable = this.dataParams.mockData.slice(
          (this.currentPage - 1) * 10,
          (this.currentPage - 1) * 10 + 10
        );
      }
    } else {
      if (this.isBaseFilterComplete()) {
        this.loader.on();
        if (this.currentPage >= this.totalPages && this.dataTable.length == 1) {
          this.currentPage = this.totalPages;
        }

        let options = {
          page: this.currentPage,
          filters: [
            ...this.filtersList.map((filter) => {
              return {
                s: filter.s,
                v: filter.v,
                o: filter.o,
              };
            }),
            ...this.baseFiltersList,
          ],
        };

        this.rest
          .get(
            `${
              (this.dataParams.customEndpoints?.read ? this.dataParams.customEndpoints?.read : this.dataParams.endpoint) +
              (this.dataParams.addExtraEndpointAfterEndpoint
                ? this.dataParams.addExtraEndpointAfterEndpoint
                : '')
            }?options=${JSON.stringify(options)}`
          )
          .subscribe({
            next: (response: any) => {
              let myData = []
              if (this.dataParams.isPaginated) {
                this.totalItems = response.items;
                myData = response.data;
                this.totalPages = response.totalPages;
                this.currentPage = response.currentPage;
              } else {
                this.totalItems = response.length;
                myData = response;
              }
              this.dataTable = myData.map((data: any) => {
                this.dataParams.table.forEach((tableElement) => {
                  if (tableElement.tableElementToVisualize && tableElement.tableElementToVisualize.length > 0) {
                    tableElement.tableElementToVisualize.forEach((singlePath) => {
                      if (!data[tableElement.element + 'ToVisualize']) {
                        data[tableElement.element + 'ToVisualize'] = ""
                      }
                      if (singlePath.useFixedValue) {
                        data[tableElement.element + 'ToVisualize'] = data[tableElement.element + 'ToVisualize'] + singlePath.paths[0]
                      } else {
                        if (singlePath.isObject) {
                          data[tableElement.element + 'ToVisualize'] = singlePath.paths.reduce((acc: any, key: any) => {
                            if (acc === null || acc === undefined) return '';
                            return acc[key];
                          }, data)
                        } else {
                          data[tableElement.element + 'ToVisualize'] = data[tableElement.element + 'ToVisualize'] + singlePath.paths.reduce((acc: any, key: any) => {
                            if (acc === null || acc === undefined) return '';
                            return acc[key];
                          }, data)
                        }
                      }
                    });
                  }
                });
                return data
              })
              this.loader.off(true);
            },
            error: () => {
              this.loader.off(true);
            },
          });
      }
    }
  }

  setItemBefore(item:any){
    this.currentItemBeforeChanges = JSON.parse(JSON.stringify(item))
  }

  isBaseFilterComplete() {
    let isFilterComplete = true;
    if (
      this.dataParams?.baseFilters &&
      this.dataParams?.baseFilters?.length > 0
    ) {
      this.dataParams.baseFilters.forEach((element: any) => {
        if (
          !this.baseFiltersList.find(
            (baseF: any) => baseF.s === element.value
          ) &&
          element.obligatory
        ) {
          isFilterComplete = false;
        }
      });
    }
    return isFilterComplete;
  }

  initEdit() {
    this.showModal = true;
  }

  deleteElement(t: any) {
    this.showModalDelete = false;
    this.loader.on();
    this.rest
      .delete(`${this.dataParams.customEndpoints?.delete ? this.dataParams.customEndpoints?.delete : this.dataParams.endpoint}/${this.currentItem[this.elementId]}`)
      .subscribe({
        next: () => {
          if (
            this.currentPage >= this.totalPages &&
            this.dataTable.length == 1
          ) {
            this.currentPage = 1;
          }
          this.loader.off(true);
          this.getTableData();
        },
        error: () => {
          this.loader.off(true);
          this.message.showMessage(t('errorDelete'), 'error');
          this.getTableData();
        },
      });
  }

  showMessage(message: string, status: string) {
    this.message.showMessage(message, status);
  }

  mangageSelect(event: any, dataForm: any, isMultiple?: boolean) {
    let itemToEdit = this.currentItem ? this.currentItem : this.customForm;
    if (isMultiple) {
      itemToEdit[dataForm.element] = event.map((res: any) => { return res[dataForm.bindValueSelect ?? 'value'] });
    } else {
      itemToEdit[dataForm.element] = event[dataForm.bindValueSelect ?? 'value'];
    }
  }

  isFormComplete() {
    let itemToCheck = this.currentItem ? this.currentItem : this.customForm;
    let isCompleted = true;

    this.dataParams.table.forEach((myElement: any) => {
      if (
        myElement.obligatory &&
        !(
          itemToCheck[myElement.element] ||
          itemToCheck[myElement.element] === false
        ) &&
        (this.currentItem ? myElement.editable : myElement.creation)
      ) {
        isCompleted = false;
      }
    });
    return isCompleted;
  }

  getCurrentValue(myValue: any, data: any, dataForm: any,isMultiple?:boolean) {
    console.log('gino');
    
    let startingElement = null
    if(isMultiple){
      if(dataForm.multipleSelectArrayValue){
        startingElement = myValue.map((res:any)=>{
          return {value:res,label:res}
        })
      }else{
      startingElement = myValue}
    }else{
    startingElement = (data ?? dataForm.selectArray).find(
      (res: any) =>
        res[
          dataForm.startingSubElement ?? dataForm.bindValueSelect ?? 'value'
        ] == myValue
    );}
    
    
    return startingElement;
  }

  onModalConfirm(t: any) {
    let currentItem = JSON.parse(
      JSON.stringify(this.currentItem ?? this.customForm)
    );

    if (this.dataParams?.elementToRemove) {
      this.dataParams?.elementToRemove.forEach((element: string) => {
        delete currentItem[element];
      });
    }

    this.dataParams.table.forEach(tableElement => {
     if(tableElement.type == 'number'){
     currentItem[tableElement.element] = parseFloat(currentItem[tableElement.element])}
    });

    if(!this.dataParams.requirePut && this.currentItem){
    for (const key in this.currentItemBeforeChanges) {
      if (!Object.hasOwn(this.currentItemBeforeChanges, key)) continue;
      let beforeComparation = JSON.stringify(this.currentItemBeforeChanges[key])
      let currentComparation = JSON.stringify(currentItem[key])
      if(beforeComparation == currentComparation || this.currentItemBeforeChanges[key] == currentItem[key]){
        delete currentItem[key]
        console.log(currentItem);
        
      }
    }}

    if(JSON.stringify(currentItem) == '{}'){
      this.showMessage(t('editIsEmpty'),'error')
    }else{

    for (const [key, value] of Object.entries(currentItem)) {
      this.myCustomFormData.append(key, value);
    }
    this.showModal = false;
    let myFunction = this.currentItem
      ? ( this.dataParams.requirePut ? this.rest.put(
          `${this.dataParams.customEndpoints?.update ? this.dataParams.customEndpoints?.update : this.dataParams.endpoint}/${this.currentItem[this.elementId]}`,
          this.dataParams.useFormData ? this.myCustomFormData : currentItem
        ) : this.rest.patch(
          `${this.dataParams.customEndpoints?.update ? this.dataParams.customEndpoints?.update : this.dataParams.endpoint}/${this.currentItem[this.elementId]}`,
          this.dataParams.useFormData ? this.myCustomFormData : currentItem
        ))
      : this.rest.post(
          `${this.dataParams.customEndpoints?.create ? this.dataParams.customEndpoints?.create : this.dataParams.endpoint}`,
          this.dataParams.useFormData ? this.myCustomFormData : currentItem
        );
    myFunction.subscribe({
      next: () => {
        this.myCustomFormData = new FormData();
        this.currentPage = 1;
        this.totalPages = 1;
        this.getTableData();
      },
      error: () => {
        this.myCustomFormData = new FormData();
        this.message.showMessage(t('errorCreation'), 'error');
        this.loader.off(true);
      },
    });}
  }
}